import { NGXLogger } from 'ngx-logger';
import { Directive, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { ScrAuthorizationService } from '../services/authorization.service';
 
@Directive({
  selector: '[appAuthIf]'
})
export class AuthIfDirective {
  constructor(private scrAuthorizationService: ScrAuthorizationService,
    private templateRef: TemplateRef<object>,
    private logger: NGXLogger,
    private viewContainer: ViewContainerRef) {
 
  }
 
  @Input() set appAuthIf(allowedGroups: string[]) {
      this.scrAuthorizationService.getAuthorizedGroups().subscribe(groups => {
        if (groups && allowedGroups.some((val: string) => groups.includes(val))) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      }, error => {
        this.logger.error(error);
      });
    }
}


@Directive({
  selector: '[appAuthIfCombined]'
})
export class AuthIfCombinedDirective {
  constructor(private scrAuthorizationService: ScrAuthorizationService,
    private templateRef: TemplateRef<object>,
    private logger: NGXLogger,
    private viewContainer: ViewContainerRef) {
 
  }
 
  @Input() set appAuthIfCombined(combinedGroups: string[][]) {
    this.scrAuthorizationService.getAuthorizedGroups().subscribe(authGroups => {
      this.viewContainer.clear();
      if (authGroups) {
        for (const group of combinedGroups) {
          if (group.every((val: string) => authGroups.includes(val))) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            break;
          }
        }
      }
    }, error => {
      this.logger.error(error);
    });
  }


}

@Directive({
  selector: '[appNotAuthIf]'
})
export class NotAuthIfDirective {
  constructor(private scrAuthorizationService: ScrAuthorizationService,
    private templateRef: TemplateRef<object>,
    private logger: NGXLogger,
    private viewContainer: ViewContainerRef) {
 
  }
 
  @Input() set appNotAuthIf(allowedGroups: string[]) {
      this.scrAuthorizationService.getAuthorizedGroups().subscribe(groups => {
        if (groups && !allowedGroups.some((val: string) => groups.includes(val))) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      }, error => {
        this.logger.error(error);
      });
    }
}

